package modysy.model

import modysy.datastructures.Vector2

/** Represents the shape of the physical body and provides calculation of area, inertia and containment.
  *
  */
sealed trait Geometry {

  /** Area of the geometric shape. */
  def area: Double

  /** A function that calculates inertia around the origin given mass. */
  val calculateIntertia: Double => Double

  /** Check if the point in the local frame of the shape is contained within it. */
  def contains(point: Vector2): Boolean
}

/** A circle with a specified radius. The origin lies in the center. */
case class Circle(radius: Double) extends Geometry {
  require(radius > 0)

  val area: Double = math.Pi * math.pow(radius, 2)

  private val squaredRadius = radius * radius

  override val calculateIntertia: Double => Double = mass =>
    mass * math.pow(radius, 2) / 2

  override def contains(point: Vector2): Boolean =
    point.squaredNorm <= squaredRadius
}

/** A box with a specified width and height. The origin lies in the center of the box. */
case class Box(width: Double, height: Double) extends Geometry {
  require(height > 0 && width > 0)

  val area: Double = height * width

  override def contains(point: Vector2): Boolean =
    math.abs(point.x) <= width / 2 && math.abs(point.y) <= height / 2

  /** Four corner points of the box in local frame. */
  val points: Seq[Vector2] = {
    List(
      (-width / 2, -height / 2),
      (-width / 2, height / 2),
      (width / 2, height / 2),
      (width / 2, -height / 2)
    )
  }

  override val calculateIntertia: Double => Double = mass =>
    mass * (math.pow(height, 2) + math.pow(width, 2)) / 12
}

case class PortalCircle(radius: Double) extends Geometry {
  require(radius > 0)

  val area: Double = math.Pi * math.pow(radius, 2)

  private val squaredRadius = radius * radius

  override val calculateIntertia: Double => Double = mass =>
    mass * math.pow(radius, 2) / 2

  override def contains(point: Vector2): Boolean =
    point.squaredNorm <= squaredRadius
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/model/Geometry.scala